// import
import React, { Component }  from 'react';
import Dashboard from "views/Dashboard/Dashboard.js";
import Tours from "views/Dashboard/Tours.js";
import Files from "views/Dashboard/Files.js";
import Support from "views/Dashboard/Support.js";
import Guide from "views/Dashboard/Guide.js";
import Rooms from "views/Dashboard/Rooms.js";
import Profile from "views/Dashboard/Profile.js";
import Popups from "views/Dashboard/Popups.js";
import ChatRooms from "views/Dashboard/ChatRoom.js";
import Menu from "views/Dashboard/Menu.js";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";
import TourDetails from "views/Dashboard/TourDetails.js";
import RoomDetails from "views/Dashboard/RoomDetails.js";
import SendOTPCode from "views/Auth/SendCode.js";
import VerifyCode from "views/Auth/VerifyCode.js";
import CallBack from 'views/Dashboard/PaymentCallback';

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";
import Landing from 'views/Dashboard/Landing';

var dashRoutes = [
  {
    path: "/payment/callback",
    name: "CallBack",
    rtlName: "بازگشت از بانک",
    icon: <HomeIcon color='inherit' />,
    component: CallBack,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/rooms/:address/details/:id",
    name: "Room Details",
    rtlName: "جزییات ایستگاه",
    icon: <HomeIcon color='inherit' />,
    component: RoomDetails,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/tour/details/:id",
    name: "Tour Details",
    rtlName: "جزییات تور",
    icon: <HomeIcon color='inherit' />,
    component: TourDetails,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/signup",
    name: "SignUp",
    rtlName: "ثبت نام",
    icon: <HomeIcon color='inherit' />,
    component: SignUp,
    layout: "/auth",
    redirect:true
  },
  {
    path: "/signin",
    name: "SignIn",
    rtlName: "ورود",
    icon: <HomeIcon color='inherit' />,
    component: SignIn,
    layout: "/auth",
    redirect:true
  },
  {
    path: "/sendcode",
    name: "SendCode",
    rtlName: "ورود با رمز یکبار مصرف",
    icon: <HomeIcon color='inherit' />,
    component: SendOTPCode,
    layout: "/auth",
    redirect:true
  },
  {
    path: "/verifycode",
    name: "VerifyCode",
    rtlName: "ثبت کد پیامک شده",
    icon: <HomeIcon color='inherit' />,
    component: VerifyCode,
    layout: "/auth",
    redirect:true
  },
  {
    path: "/rooms/:address/:tourname?",
    name: "Rooms",
    rtlName: "ایستگاه‌ها",
    icon: <HomeIcon color='inherit' />,
    component: Rooms,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/chatrooms/:address/:tourname?",
    name: "Rooms",
    rtlName: "چت روم",
    icon: <HomeIcon color='inherit' />,
    component: ChatRooms,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/menus/:address/:tourname?",
    name: "Menu",
    rtlName: "چت روم",
    icon: <HomeIcon color='inherit' />,
    component: Menu,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/popups/:address/:tourname?",
    name: "Popups",
    rtlName: "پاپ آپ‌ها",
    icon: <HomeIcon color='inherit' />,
    component: Popups,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/landing/:address/:tourname?",
    name: "Popups",
    rtlName: "صفحه فرود",
    icon: <HomeIcon color='inherit' />,
    component: Landing,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/guide",
    name: "Guide",
    rtlName: "راهنمای استفاده",
    icon: <HomeIcon color='inherit' />,
    component: Guide,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "داشبورد",
    icon: <HomeIcon color='inherit' />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tours",
    name: "Tours",
    rtlName: "تور ها",
    icon: <StatsIcon color='inherit' />,
    component: Tours,
    layout: "/admin",
  },
  {
    path: "/files",
    name: "Files",
    rtlName: "فایل ها",
    icon: <StatsIcon color='inherit' />,
    component: Files,
    layout: "/admin",
  },
  {
    path: "/popups/",
    name: "Popups",
    rtlName: "پاپ آپ‌ها",
    icon: <HomeIcon color='inherit' />,
    component: Popups,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "profile",
    rtlName: "حساب کاربری",
    icon: <SupportIcon color='inherit' />,
    component: Profile,
    layout: "/admin",
    redirect:true
  },
  {
    path: "/support",
    name: "Support",
    rtlName: "پشتیبانی",
    icon: <SupportIcon color='inherit' />,
    component: Support,
    layout: "/admin",
  }
  
];
export default dashRoutes;
